const dateTimeFormats = {
  fr: {
    long: {
      dateStyle: 'long',
      timeStyle: 'short'
    }
  },
  pt: {
    long: {
      dateStyle: 'long',
      timeStyle: 'short'
    }
  }
}

export default dateTimeFormats
